// A credencial de biometria é criada pelo autenticador do aparelho, e o servidor
// não sabe de qual aparelho veio cada uma. Este navegador guarda o que registrou
// aqui — e o que recusou — para decidir se vale convidar o usuário a cadastrar.

const REGISTRADAS = 'passkey.credentials'
const RECUSA = 'passkey.declined'

// O servidor guarda o identificador em base64 e o navegador o devolve em
// base64url; comparar exige uma forma só.
const normalize = (id) => (id || '').replace(/-/g, '+').replace(/_/g, '/').replace(/=+$/, '')

const read = (key, fallback) => {
  try {
    const value = window.localStorage.getItem(key)

    return value === null ? fallback : JSON.parse(value)
  } catch (err) {
    return fallback
  }
}

const write = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value))
  } catch (err) {
  }
}

export default {
  methods: {
    // Guarda o identificador da credencial recém-criada neste aparelho.
    passkeyRemember (id) {
      const normalized = normalize(id)

      if (!normalized) return

      const ids = read(REGISTRADAS, [])

      if (ids.includes(normalized)) return

      ids.push(normalized)

      write(REGISTRADAS, ids)
    },

    // Alguma das credenciais da conta foi criada aqui?
    passkeyRegisteredHere (accountIds) {
      const ids = read(REGISTRADAS, [])

      return (accountIds || []).some(id => ids.includes(normalize(id)))
    },

    // A recusa é anotada junto das credenciais que a conta tinha na ocasião: se
    // esse conjunto mudar — porque o usuário registrou em outro aparelho ou
    // removeu o que tinha —, o convite volta a fazer sentido.
    passkeyDecline (accountIds) {
      write(RECUSA, (accountIds || []).map(normalize).sort())
    },

    passkeyDeclined (accountIds) {
      const declined = read(RECUSA, null)

      if (declined === null) return false

      const current = (accountIds || []).map(normalize).sort()

      return JSON.stringify(declined) === JSON.stringify(current)
    }
  }
}
